<template>
  <div>
    <div id="north">
      <header-info cur="2"></header-info>
    </div>
    <div id="menu"></div>
    <div id="center">
      <div
        id="content"
        class="content"
      >

        <div class="center_content">
          <form
            id="searchSection"
            onSubmit="return false;"
          >
            <div class="menu">
              <div class="menubox hidebox">
                <div class="sort clearfix">
                  <div class="title">专业大类</div>
                  <div class="tab-list subjectList">
                    <ul class="clearfix">
                      <li
                        data="all"
                        @click="onClick='',getCategory('', '')"
                        :class="{'on':onClick===''}"
                      >全部</li>
                      <li
                        @click="getCategory(item.id,index)"
                        :class="{'on':onClick===index}"
                        v-for="(item,index) in categoryData"
                        data="7"
                        :key="index"
                      >{{item.title}}</li>
                    </ul>
                  </div>
                </div>
                <div
                  class="sort clearfix subject2Wrap"
                  :class="{'hide':onClick===''}"
                >
                  <div class="title">专业分类</div>
                  <div class="tab-list subject2List">
                    <ul class="clearfix">
                      <li
                        data="all"
                        @click="onClick2='',queryInfo.subject_id='',getOnlineCourse()"
                        :class="{'on':onClick2===''}"
                      >全部</li>
                      <li
                        @click="onClick2=index,queryInfo.subject_id=item.id,getOnlineCourse()"
                        :class="{'on':onClick2===index}"
                        v-for="(item,index) in subjectData"
                        data="7"
                        :key="index"
                      >{{item.title}}</li>
                    </ul>
                  </div>
                </div>
                <div class="sort clearfix">
                  <div class="title">课程状态</div>
                  <div class="tab-list subjectList">
                    <ul class="clearfix">
                      <li
                        data="all"
                        @click="onClick3='', queryInfo.time_status='',getOnlineCourse()"
                        :class="{'on':onClick3===''}"
                      >全部</li>
                      <li
                        @click="onClick3=1, queryInfo.time_status=1,getOnlineCourse()"
                        :class="{'on':onClick3===1}"
                      >未开始</li>
                      <li
                        @click="onClick3=2, queryInfo.time_status=2,getOnlineCourse()"
                        :class="{'on':onClick3===2}"
                      >进行中</li>
                      <li
                        @click="onClick3=3, queryInfo.time_status=3,getOnlineCourse()"
                        :class="{'on':onClick3===3}"
                      >已结束</li>
                    </ul>
                  </div>
                </div>
                <div class="sort clearfix">
                  <div class="title">关&nbsp;&nbsp;键&nbsp;&nbsp;词</div>
                  <div class="edit"><input
                      type="text"
                      v-model="queryInfo.title"
                      placeholder="请输入课程名称"
                      autocomplete="off"
                    ><input
                      type="text"
                      class="school-title"
                      v-model="queryInfo.manager_name"
                      placeholder="请输入负责人名称"
                      autocomplete="off"
                    ><button
                      type="submit"
                      class="s-btn search"
                      style="margin-bottom:0"
                      @click="pageCallback(1)"
                    >搜索</button></div>
                </div>
              </div>
            </div>
          </form>
          <div class="list-wrap clearfix hidebox">
            <div class="f-box">
              <ul
                class="project-list clearfix"
                id="projectList"
              >
                <li
                  v-for="item in tableData"
                  :key="item.id"
                >
                  <router-link :to="'/www/lesson_detail?id=' + item.id">
                    <div class="bg">
                      <div class="imgWrap">
                        <img
                          :src="item.logoPath?item.logoPath:''"
                          :onerror="$store.state.defaultImg"
                        />
                        <span v-if="formatTimeStatus(item) == 1" class="timeStatus timeStatus1">未开始</span>
                        <span v-if="formatTimeStatus(item) == 2" class="timeStatus timeStatus2">进行中</span>
                        <span v-if="formatTimeStatus(item) == 3" class="timeStatus timeStatus3">已结束</span>
                      </div>
                      <div class="text-wrap">
                        <div class="text-title">
                          <p>{{item.title}}</p>
                          <p class="p2 ">
                            <span class="m-r-md">{{ formatTerm(item.term) }}</span>|
                            <span class="m-l-md">进行第{{formatWeek(item.startTime)}}周，共{{item.allTime?item.allTime:'--'}}周</span>
                          </p>
                        </div>
                        <div>

                        </div>
                        <div>
                          <div class="p2 lesson-item">
                            <div>
                              <span :title="item.school_title?item.school_title:'--'">{{item.school_title?item.school_title:'--'}}</span>|
                              <span :title="item.manager_name?item.manager_name:'--'">{{item.manager_name?item.manager_name:'--'}}</span>
                            </div>
                            <div>
                              <span title="学习人数"><i class="iconfont">&#xe670;</i>{{item.student_count?item.student_count:'0'}}</span>
                              <span title="浏览量"><i class="iconfont">&#xe62f;</i>{{item.view_count?item.view_count:'0'}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
              <div
                v-if="!tableData.length"
                class="noMore showActive"
              >暂无内容</div>
            </div>
            <pagination
              v-if="tableData.length"
              :cur='pageInfo.page'
              :all='pageInfo.all'
              :totalData="pageInfo.totalData"
              :callback="pageCallback"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import Pagination from '../../../components/Pager'

export default {
  name: 'Search',
  metaInfo: {
    meta: [
      { name: 'keywords', content: '虚拟仿真,实验,实验项目,本科,专科,课程学习' }
    ]
  },
  components: {
    HeaderInfo,
    FooterInfo,
    Pagination
  },
  data() {
    return {
      onClick: '',
      onClick2: '',
      onClick3: '',
      categoryData: [],
      subjectData: [],
      tableData: [],
      tableDataMobile: [],
      HotData: [],
      tableDataCount: 0,
      tableDataCountMobile: 0,
      pageNum: 1,
      queryInfo: {
        page: 1,
        size: 9,
        status: 5,
        subjectCategory_id: '',
        subject_id: '',
        time_status: '',
        title: '',
        manager_name: '',
        isPub: 1
      },
      queryInfoMobile: {
        page: 1,
        size: 8,
        status: 5,
        subjectCategory_id: '',
        subject_id: '',
        title: '',
        manager_name: '',
        isPub: 1
      },
      isShow: false,
      heatRank: [],
      showPicker: false
    }
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    getNowTime () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
      const time = '' + year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second)
      return time
    },
    formatTimeStatus (item) {
      if (!item.startTime || !item.endTime) {
        return 0
      }
      const curTime = this.getNowTime()
      if (item.startTime.replace('T', ' ') > curTime) {
        return 1
      }
      if (curTime >= item.startTime.replace('T', ' ') && item.endTime.replace('T', ' ') >= curTime) {
        return 2
      }
      if (curTime > item.endTime.replace('T', ' ')) {
        return 3
      }
      return 0
    },
    formatTerm(value) {
      var term = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      let text = ''
      if (value) {
        if (value.toString().length === 1) {
          text = term[value]
        } else if (value.toString().length === 2) {
          text = term[value.toString()[0]] + '十' + term[value.toString()[1]]
        } else if (value.toString().length === 3) {
          text = term[value.toString()[0]] + '百' + term[value.toString()[1]] + '十' + term[value.toString()[2]]
        } else if (value.toString().length === 4) {
          text = term[value.toString()[0]] + '千' + term[value.toString()[1]] + '百' + term[value.toString()[2]] + '十' + term[value.toString()[2]]
        }
        return '第' + text + '学期'
      } else {
        return '-'
      }
    },
    // 计算当前时间处于第几周
    getWeek (dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = Number(d2) - Number(d1)
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(Number(days) / 7)
      return num
    },
    formatWeek(val) {
      var num = this.getWeek(val)
      return num
    },
    pageCallback(data) {
      this.queryInfo.page = data
      this.getOnlineCourse()
    },
    // 大类
    async searchSubject_category() {
      await this.$http.get('/allowany/subject_category/', {
        params: {
          page: 1,
          size: 100,
          status: 1
        }
      }).then((data) => {
        this.categoryData = data.results
        this.categoryData.forEach(element => {
          element.count = 0
        })
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 专业
    async getCategory(id, index) {
      this.onClick = index
      this.onClick2 = ''
      this.queryInfo.subjectCategory_id = id
      this.queryInfo.subject_id = ''
      this.tableData = []
      this.subjectData = []
      this.getOnlineCourse()
      await this.$http.get('/allowany/subject/', {
        params: {
          page: 1,
          size: 100,
          status: 1,
          subject_category_id: id
        }
      }).then((data) => {
        this.subjectData = data.results
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 汇总大类实验数量
    CategoryTotal(item) {
      var total = 0
      item.forEach(element => {
        total += element.count
      })
      return total
    },
    // 汇总专业实验数量
    SubjectTotal(item) {
      var total = 0
      item.forEach(element => {
        total += element.experiment_count
      })
      return total
    },
    // 实验
    async getOnlineCourse() {
      this.tableData = []
      this.tableDataCount = 0
      await this.$http.get('/lesson_search/', {
        params: this.queryInfo
      }).then((data) => {
        if (data.code === '200') {
          this.tableData = data.data.results
          this.tableDataCount = data.data.count
        }
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 实验
    async getOnlineCourseMobile() {
      await this.$http.get('/allowany/lesson_online/', {
        params: this.queryInfoMobile
      }).then((data) => {
        if (this.queryInfoMobile.page === 1) {
          this.tableDataMobile = data.results
        } else {
          this.tableDataMobile = this.tableDataMobile.concat(data.results)
        }
        this.tableDataCountMobile = data.count
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    loadMore() {
      this.pageNum = this.pageNum + 1
      this.queryInfoMobile.page = this.pageNum
      this.getOnlineCourseMobile()
    }

  },
  mounted() {
    window.screenWidth = document.body.clientWidth
    if (window.screenWidth < 1000) {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
      }
      this.getOnlineCourseMobile()
    } else {
      this.getOnlineCourse()
    }

    this.searchSubject_category()
  },
  watch: {
    $route: {
      handler() {
        this.queryInfo.title = this.$route.query.title
        this.getOnlineCourse()
      },
      immediate: true
    }
  }
}
</script>
<style scoped src="../../../assets/css/dialog.css"></style>
<style scoped src="../../../assets/css/common.css"></style>
<style scoped src="../../../assets/css/header.css"></style>
<style scoped src="../../../assets/css/project-list.css"></style>
<style lang="less" scoped>
/deep/.header_container {
  .logo {
    width: 245.5px;
    height: 80px;
    background: url(../../../assets/images/logo.png) no-repeat center center;
    background-size: 100%;
    margin-left: 4.2%;
  }
}
#searchSection .s-btn:hover {
  background: #12BDAA;
}
.hideActive {
  display: none;
}
.showActive {
  display: block;
}
.imgWrap {
  position: relative;
}
.imgWrap .timeStatus {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 70px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: white;
}
.imgWrap .timeStatus1 {
  background-color: greenyellow;
}
.imgWrap .timeStatus2 {
  background-color: orangered;
}
.imgWrap .timeStatus3 {
  background-color: darkgray;
}

.mark {
  position: absolute;
  left: 0;
  top: 0;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
  border-bottom-right-radius: 5px;
}
.mark0 {
  background: #eb6736;
}
.mark1 {
  background: #009999;
}
.mark2 {
  background: #ff9000;
}
.list-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
  margin-bottom: 30px;
  .f-box {
    width: 1200px;
    margin: 0 auto 30px;
    float: none;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
    ul {
      li {
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}

.imgWrap img {
  width: 350px;
  height: 183px;
  transition: 0.5s;
}

.experiment-pop {
  width: 370px;
  height: 248px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(50, 50, 50, 0.6);
  opacity: 0;
  transition: all 0.5s;
}
.experiment-pop .editbox {
  padding: 20px;
}
.experiment-pop .editbox .word {
  font-size: 16px;
  color: #fff;
  margin-top: 10px;
}
.experiment-pop .editbox .intro {
  color: #ddd;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}
#app #center {
  padding-bottom: 0;
}
.menu {
  width: 100%;
  min-height: 190px;
  //background: url(../../../assets/images/bg.jpg) no-repeat;
  background-color: #BDEBE6;
  background-size: 100% 100%;
}

.center_content {
  padding-bottom: 80px;
}

.text-wrap {
  .text-title {
    p {
      font-size: 15px;
      color: #333;
    }
    .p2 {
      margin: 5px auto 20px;
    }
  }
  .p2 {
    display: flex;
    align-items: center;
  }
}
.noMore {
  margin-bottom: 0;
}
.list-wrap .f-box ul li .text-wrap .lesson-item {
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-wrap .f-box ul li .text-wrap .lesson-item div:first-child {
  display: flex;
  justify-content: flex-start;
}
.list-wrap .f-box ul li .text-wrap .lesson-item div:first-child span {
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-wrap .f-box ul li .text-wrap .lesson-item div span:first-child {
  margin-right: 10px;
  i {
    margin-right: 5px;
  }
}
.list-wrap .f-box ul li .text-wrap .lesson-item div span:last-child {
  margin-left: 5px;
  i {
    margin-right: 5px;
  }
}
.m-r-md {
  margin-right: 10px;
}
.m-l-md {
  margin-left: 10px;
}
.load-more {
  width: 100px;
  height: 30px;
  border: 1px solid #73D6CA;
  text-align: center;
  line-height: 30px;
  color: #73D6CA;
  margin: 20px auto;
  position: relative;
  z-index: 100;
}
</style>
